/* longlabel:
 *
 * Add class bb-p-longlabel to questiongroup
 *
 * Author: Niels Giesen
 * Copyright 2015 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  var threshold = 92;

  $(function () {
    $(doc).on("bb:postHandleData", function (event, data) {
      if (data && data.groups) {
        $(".group .bb-questionlabelgroup").each(setClass);
      }
    });
  });

  function setClass() {
    var $this = $(this);
    if ($this.find("label").text().length > threshold)
      $this.addClass("bb-p-longlabel");
  }
})(jQuery, window, document);
